/** PWA plumbing: service-worker registration + the "Install app" prompt. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let deferred: any = null;
const listeners = new Set<() => void>();
const notify = (): void => listeners.forEach((f) => f());

export function initPwa(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e;
    notify();
  });
  window.addEventListener('appinstalled', () => { deferred = null; notify(); });
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => {}); });
  }
}

export function canInstall(): boolean { return deferred !== null; }
export function isStandalone(): boolean {
  return typeof matchMedia !== 'undefined' && matchMedia('(display-mode: standalone)').matches;
}
export async function promptInstall(): Promise<void> {
  if (!deferred) return;
  const p = deferred;
  deferred = null;
  notify();
  try { await p.prompt(); } catch { /* user dismissed */ }
}
export function onInstallChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
